import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const OnboardingOverlay = () => {
  const { overlayDiv } = useStyles();

  return <div className={overlayDiv}></div>;
};

const useStyles = makeStyles((theme) => {
  return {
    overlayDiv: {
      position: 'fixed',
      display: 'block',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255,255,255,0.9)',
      zIndex: theme.zIndex.modal,
    },
  };
});

export default OnboardingOverlay;
